import { render, staticRenderFns } from "./BusinessSolutionForm.vue?vue&type=template&id=da2575d2&scoped=true&"
import script from "./BusinessSolutionForm.vue?vue&type=script&lang=js&"
export * from "./BusinessSolutionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2575d2",
  null
  
)

export default component.exports